import { store } from '../../../../../resources/frontend/js/store';
import {checkWorkTypeOverride} from '../worktype-override';
export default (questionId) => {
    const storeQuiz = store.state.quiz;

    if (!questionId) {
        storeQuiz.questionCount--;
        storeQuiz.currentQuestion--;
        storeQuiz.questionFlow.pop();
        checkWorkTypeOverride();
    }

    // TODO: Add remaining logic for when there is a questionId.
};
